import { CellContext } from '@tanstack/react-table';
import { BundleDetails } from '@/types/bundles.types';

const BundleLibraryTablePriceCell = (props: CellContext<BundleDetails, any>) => {
  if (props.row.original.availablePrices?.length > 0) {
    const sortedPrices = props.row.original.availablePrices?.sort((a: number, b: number) => a - b);
    return sortedPrices.length <= 1
      ? `$${sortedPrices[0].toFixed(2)}`
      : `$${sortedPrices[0].toFixed(2)} - $${sortedPrices[sortedPrices.length - 1].toFixed(2)}`;
  }
  return '-';
};

export default BundleLibraryTablePriceCell;
